import React, { useContext, useEffect, useState } from "react";
import { FRONT_URL, LINE_ID, LINE_SECRET, api} from "../../proxy";
import axios from "axios";
import { useLocation } from "react-router";
import { useNavigate } from 'react-router-dom';
import { LoginContext } from "../../contexts/LoginContext";
import { login_success } from "../../constants/actionTypes";
import { Backdrop, CircularProgress } from "@mui/material";


const checkRegistration = async (profile: { email: string }) => {
  try {
    const response = await api.post(`/auth/line?email=${profile.email}`,
      profile
    );
    return response.data;
  } catch (error) {
    console.error(error);
    // 处理错误情况
  }
};



const Linelogin = () => {
  const [lineProfile, setLineProfile] = useState<any>(null);
  const state = "samko0927";
  const navigate = useNavigate();
  const handleLogin = () => {
    const encodedRedirectUri = encodeURIComponent(`${FRONT_URL}login`);
    window.location.replace(
      `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${LINE_ID}&redirect_uri=${encodedRedirectUri}&state=${state}&scope=profile%20openid%20email`
    );
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const { error, dispatch } = useContext(LoginContext)
  const [submitLoading, setSubmitLoading] = useState(false)
  useEffect(() => {
    const fetchAccessToken = async () => {
      const tokenEndpoint = "https://api.line.me/oauth2/v2.1/token";
      const grantType = "authorization_code";
      if (code) {
        try {
          setSubmitLoading(true)
          const response = await axios.post(tokenEndpoint, new URLSearchParams({
            grant_type: grantType,
            code: code,
            client_id: LINE_ID ||"",
            client_secret: LINE_SECRET||"",
            redirect_uri: `${FRONT_URL}login`||""
          }), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
          const accessToken = response.data.access_token;
          const id_token = response.data.id_token

          //get line email
          const profileEndpoint = "https://api.line.me/oauth2/v2.1/verify";
          const profileResponse = await axios.post(profileEndpoint, new URLSearchParams({
            id_token: id_token,
            client_id: LINE_ID||"",
          }), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          });
          // Check if the user is registered
          const LoginResponse = await api.post(`/auth/line?email=${profileResponse.data.email}`,
            profileResponse.data
          );
          // Redirect to the home page if the user is registered￼
          //並更新dispatch
          console.log(LoginResponse)
          if(LoginResponse.data){
            setSubmitLoading(false)
            dispatch({ type: login_success, payload: LoginResponse.data })
            navigate('/');
          }

        } catch (error) {
          console.error(error);
          // Handle the error here
        }
      }
    };
    fetchAccessToken();
  }, [code]);

  return (
    <div className="LineLogin">
      <button onClick={handleLogin}>
        <div className="line-icon"></div>
        LINE 登入</button>
        <Backdrop open={submitLoading} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                    <CircularProgress color="inherit" />
        </Backdrop>
    </div>
  );
};

export default Linelogin;
function generateRandomState() {
  throw new Error("Function not implemented.");
}